/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import AccountsContainer from './AccountsContainer';
import CreateAccountContainer from "./CreateAccountContainer";
import EditAccountContainer from "./EditAccountContainer";
import DisableAccountContainer from "./DisableAccountContainer";
import EnableAccountContainer from "./EnableAccountContainer";

export default class AccountsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<AccountsContainer/>} />
                <Route path="/create-account" element={<CreateAccountContainer/>} />
                <Route path="/:id/managed-accounts" element={<EditAccountContainer/>} />
                <Route path="/:id/disable-account" element={<DisableAccountContainer/>} />
                <Route path="/:id/enable-account" element={<EnableAccountContainer/>} />
            </Routes>
        );
    }
}
